import * as React from 'react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DynamicForm from '../../../../../core/presentations/DynamicForm';
import Validators from '../../../../../ui/helpers/validators';
import TopLabelFieldTemplate from '../../../../../ui/templates/fields/TopLabelFieldTemplate';
import VerticalFormTemplate from '../../../../../ui/templates/objects/VerticalFormTemplate';
import PrwcBasicButton from '../../../../../ui/widgets/custom/buttons/PrwcBasicButton';
import "./ShiftCategory.scss";

type ShiftCategoryProps = {
  data: any
};

const ShiftCategory = (props: ShiftCategoryProps) => {
  // const { data } = props;
  const { t } = useTranslation();
  const submitButtonRef: any = useRef(null);
  const [formData, setFormData] = useState(null);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const onSubmit = (data: any) => {
    console.log("data submitted ---");
    console.log(data);
  };

  const onError = (data: any) => {
    console.log("on error ---");
    console.log(data);
  };

  const handleOnSubmit = () => {
    // It is to submit form programmatically.
    submitButtonRef.current.click();
  };

  const formButtons = () => {
    return (
      <button ref={submitButtonRef} type="submit" className="hidden p-col-12" />
    );
  };

  const schema: any = {
    title: t("shiftCategory.label.general"),
    type: "object",
    properties: {
      shiftCategoryName: {
        type: "string",
        title: t("shiftCategory.label.categoryName"),
      },
      abbreviation: {
        type: "string",
        title: t("shiftCategory.label.abbreviation"),
      },
      description: {
        type: "string",
        title: t("shiftCategory.label.description"),
      },
    },
    required: ["shiftCategoryName"],
  };

  const validationSchema: any = {
    shiftCategoryName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "shiftCategory.validation.shiftCategoryNameRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 15);
          },
          messageKey: "shiftCategory.validation.shiftCategoryNameMaxLength",
        }
      ],
    },
    abbreviation: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 15);
          },
          messageKey: "shiftCategory.validation.abbreviationMaxLength",
        },
      ],
    },
    description: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 100);
          },
          messageKey: "shiftCategory.validation.descriptionMaxLength",
        },
      ],
    },
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    shiftCategoryName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    abbreviation: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    description: {
      "ui:widget": "prwInputTextArea",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
  };

  return (
    <div className="shift-category">
      <div className="px-4 overflow-y-auto content-height">
        <DynamicForm
             onChange={onChange}
             formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
      <div className="flex justify-end px-2 border-t">
        <PrwcBasicButton
          onClick={handleOnSubmit}
          labelKey="generic.action.save"
          className="w-24 h-8 my-1 bg-blue-700 border-blue-700 p-button-sm"
        ></PrwcBasicButton>
      </div>
    </div>
  );
};

export default ShiftCategory;
